import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'
// Login and Registers
import Register from '@/components/Register'
import Login from '@/components/Login'

// Groups
import Groups from '@/components/Groups/GroupsIndex'
import CreateGroup from '@/components/CreateGroup/CreateGroupIndex'
import EditGroup from '@/components/EditGroup'
import ViewGroup from '@/components/ViewGroup/ViewGroupIndex'

import EditClientsInGroup from '@/components/EditClientsInGroup/EditClientsInGroupIndex'

// Admin/restricted functions
import Users from '@/components/Users/UsersIndex'
import CreateUser from '@/components/CreateUser'
import EditUser from '@/components/EditUser'
//import ViewUser from '@/components/ViewUser/ViewUserIndex'

//import ViewPDF from '@/components/ViewPDF'

import EditMe from '@/components/EditMe'

// Clients are going to be the Test-takers
//import ClientsGroup from '@/components/Clients/ClientsIndex'
import Clients from '@/components/Clients/ClientsIndex'
import ViewClient from '@/components/ViewClient/ViewClientIndex'

// Copyright page
import Copyright from '@/components/Copyright'

import ForgotPassword from '@/components/ForgotPassword'
import ResetLink from '@/components/ResetLink'
import ResetPasswordSubmitted from '@/components/ResetPasswordSubmitted'
// import ResetPassword from '@/components/ResetPassword'
import PasswordChanged from '@/components/PasswordChanged'
import NotFound from '@/components/NotFound'



Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{ 	path: '/',
			redirect: '/login'
		},
		{
			path: '/register',
			name: 'register',
			component: Register
		},
		{
			path: '/login',
			name: 'login',
			component: Login
		},
		{
			path: '/groups',
			name: 'groups',
			component: Groups
		},
		{
			path: '/groups/:groupId',
			name: 'group',
			component: ViewGroup
		},
		{
			path: '/groups/create',
			name: 'groups-create',
			component: CreateGroup
		},
		{
			path: '/groups/:groupId/edit',
			name: 'group-edit',
			component: EditGroup
		},
		{
			path: '/groups/:groupId/edit/clients',
			name: 'group-edit-clients',
			component: EditClientsInGroup
		},
		{
			path: '/clients',
			name: 'clients',
			component: Clients
		},
		{
			path: '/clients-min',
			name: 'clients-min',
			component: Clients
		},
		{
			path: '/clients/:clientId',
			name: 'client',
			component: ViewClient
		},
		{
			path: '/copyright',
			name: 'copyright',
			component: Copyright
		},
		{
			path: '/users',
			name: 'users',
			component: Users
		},
		{
			path: '/users/create',
			name: 'users-create',
			component: CreateUser
		},
		{
			path: '/users/:userId/edit',
			name: 'user-edit',
			component: EditUser
		},
		// {
		// 	path: '/users/:userId',
		// 	name: 'user',
		// 	component: ViewUser
		// },
		{
			path: '/me/:userId/edit',
			name: 'me-edit',
			component: EditMe, //,
			beforeEnter: (to, from, next) => {
				 
				 let requestedUser = to.params.userId
				 let actualUser = store.state.user.id
				 if (requestedUser === actualUser) {
					 next()
				 } else {
					next({  name: 'me-edit',
					params: {
					  userId: actualUser
					}
				  }) 
				 }
			}
		},
		{
			path: '/forgotPassword',
			name: 'forgot-password',
			component: ForgotPassword
		},
		{
			path: '/resetPasswordSubmitted',
			name: 'reset-password-submitted',
			component: ResetPasswordSubmitted
		},
		{
			path: '/resetLink',
			name: 'reset-password',
			component: ResetLink
		},
		{
			path: '/passwordChanged',
			name: 'password-changed',
			component: PasswordChanged
		},
		{
			path: '*',
			name: 'not-found',
			component: NotFound
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js